import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {changeURL, colors, currencySymbol, getMediaURL, price, truncate} from "../../../../config/values";
import Button from "@material-ui/core/Button/Button";
import { Link as ReactLink } from "react-router-dom";
import FilterListRoundedIcon from "@material-ui/icons/FilterListRounded";
import {Grid, MenuItem} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import queryString from "query-string";
import OpenInNewRoundedIcon from "@material-ui/icons/OpenInNewRounded";
import MakeFAQButton from "./MakeFAQButton";

class FAQs extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            {
                title: Translate.question,
                field: 'question',
                sorting:false,
                filterPlaceholder: Translate.search,
                render: rowData =>
                    truncate(rowData.question,25)
            },

            {
                title: Translate.answer,
                field: 'answer',
                sorting:false,
                filterPlaceholder: Translate.search,
                render: rowData =>
                    truncate(rowData.answer,45)
            },

            {
                title: Translate.activity,
                field: 'activity',
                render: rowData =>
                    <>
                        <MakeFAQButton item_id={rowData.id} reload={() => this.loadData()}/>
                    </>
            }
        ],
        data: [],
        loading:false,
        ChangeLoader:false
    };

    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    async onDelete(id,hasNotif = true) {
        let data = new FormData();
        data.append('item_id', id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/faqs/delete`, data, config)
            .then(response => {
                if(response.data.hasError){
                    this.props.enqueueSnackbar(response.data.message, {
                        variant: 'error',
                    });
                }else{
                    if(hasNotif){
                        this.props.enqueueSnackbar(Translate.deleteData, {
                            variant: 'success',
                        });
                    }
                }
                this.loadData();

                return true
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    render(){
        let {status,date} = this.state;
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl" className={!!this.props.widget ? "thin-table" : null}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <MaterialTable
                                        tableRef={this.tableRef}
                                        icons={tableIcons}
                                        title={<MakeFAQButton reload={() => this.loadData()}/>}
                                        localization={DataTableLocalization}
                                        columns={this.state.columns}
                                        data={query =>
                                            new Promise((resolve, reject) => {
                                                axios.get(`${defaultVariabls.url}/faqs/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                                    .then(response => {
                                                        let data = [];
                                                        // eslint-disable-next-line
                                                        response.data.data.map((row) => {
                                                            data.push({
                                                                id: row.id,
                                                                question: row.question,
                                                                answer: row.answer,
                                                                created_at: row.created_at,
                                                            })
                                                        });
                                                        resolve({
                                                            data: data,
                                                            page: response.data.current_page - 1,
                                                            totalCount: response.data.total,
                                                        })
                                                    }).catch(error => {
                                                    console.log(error.response)
                                                })
                                            })
                                        }
                                        options={{
                                            pageSize: TablePage,
                                            pageSizeOptions: TableCount,

                                        }}
                                        editable={{
                                            onRowDelete: oldData =>
                                                new Promise(resolve => {
                                                    setTimeout(() => {
                                                        resolve();
                                                        this.onDelete(oldData.id);
                                                        this.setState(prevState => {
                                                            const data = [...prevState.data];
                                                            data.splice(data.indexOf(oldData), 1);
                                                            return { ...prevState, data };
                                                        });
                                                    }, 600);
                                                }),
                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </Container>
                }
            </>

        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(FAQs)))));